import {Autocomplete, TextField, Button, Grid, Tabs, Tab} from '@mui/material';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import {action} from 'mobx';
import React from 'react';
import {taxStateDesc, TAB_TAX, TAB_DESC, TAB_BL, TAB_STATS, TAB_MEDIA, TAB_MAP, TAB_HALIAS, TAB_ATLAS, TAB_MIGR, TAB_REFS} from './TaxCommon.js';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {getShortSpecName, getSpecName} from '../Trans.js';
import {TT_SUBSPEC, TT_SPEC, TT_ORDER} from '../Util.js';
import TaxReferences from './TaxReferences.js';
import TaxMigration from './TaxMigration.js';
import BottomBar from '../BottomBar.js';
import TaxHalias from './TaxHalias.js';
import TaxAtlas from './TaxAtlas.js';
import TaxMedia from './TaxMedia.js';
import TaxStats from './TaxStats.js';
import Taxonomy from './Taxonomy.js';
import ObsAppBar from '../AppBar.js';
import TaxDesc from './TaxDesc.js';
import TaxMap from './TaxMap.js';
import TaxBl from './TaxBl.js';

export const TaxNavi = ((props) => {
	const {onPrevValid, onPrev, onNext, onNextValid} = props;

	if (window.location.pathname !== '/taxons')
		return null;

	if (!onPrev || !onNext)
		return null;

	return (
		<Grid container direction={'row'} spacing={0} style={{flexGrow: 1}} justifyContent='center'>
			<Grid>
				<Button variant="contained" color="primary" size="small" style={{width:64, margin: 8}} onClick={onPrev} disabled={onPrevValid ? !onPrevValid() : false}>&lt;&lt;</Button>
				<Button variant="contained" color="primary" size="small" style={{width:64, margin: 8}} onClick={onNext} disabled={onNextValid ? !onNextValid() : false}>&gt;&gt;</Button>
			</Grid>
		</Grid>
	);
});

const Taxons = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const getheader = () => {
		return t('taxons.taxons');
	}

	function handleTabChange(event, tab) {
		// console.log('handleTabChange', event, tab);
		gStorage.taxons.setTab(tab);
	}

	/* ------------------------------------------------------------------ */

	function browsingFilter(tax) {
		return tax.t_type === gStorage.taxons.centerTaxon.t_type && tax.p_id === gStorage.taxons.centerTaxon.p_id;
	}
	
	function prevTaxonValid() {
		if (!gStorage.lists.speclist.list || gStorage.lists.speclist.list.length <= 0)
			return false;

		return true;
	}

	function prevTaxon() {
		if (!gStorage.taxons.centerTaxon) {
			const list = gStorage.lists.speclist.list.slice().sort(sortTaxons);

			taxChange(list[list.length - 1]);
			return;
		}

		const list = gStorage.lists.speclist.list.filter(browsingFilter).sort(sortTaxons);
		let i = list.findIndex(x => x.id === gStorage.taxons.centerTaxon.id);

		i--;
		if (i < 0)
			i = list.length - 1;

		taxChange(list[i]);
	}

	function nextTaxon() {
		if (!gStorage.taxons.centerTaxon) {
			const list = gStorage.lists.speclist.list.slice().filter(x => x.t_type === TT_ORDER).sort(sortTaxons);
			taxChange(list[0]);
			return;
		}

		const list = gStorage.lists.speclist.list.filter(browsingFilter).sort(sortTaxons);

		let i = list.findIndex(x => x.id === gStorage.taxons.centerTaxon.id);

		i++;
		if (i >= list.length)
			i = 0;

		taxChange(list[i]);
	}

	function nextTaxonValid() {
		if (!gStorage.lists.speclist.list || gStorage.lists.speclist.list.length <= 0)
			return false;

		return true;
	}

	/* ------------------------------------------------------------------ */

	function taxChange(tax) {
		let i = 0;

		gStorage.taxons.setDesc(null);
		gStorage.taxons.setBl(null);
		gStorage.taxons.setMediaList(null);
		gStorage.taxons.setCenterTaxon(tax);
		gStorage.taxons.setObsList(null);
		gStorage.taxons.setHaliasData(null);
		gStorage.taxons.setAtlasData(null);
		gStorage.taxons.setMigration(null);
		gStorage.taxons.setReferences(null);

		/* TODO: stats init function */
		gStorage.taxons.setGenStats(null);
		gStorage.taxons.setStats(null);
		gStorage.taxons.setMonthStats(null);
		gStorage.taxons.setYearsStats(null);
		gStorage.taxons.setDateStats(null);

		if (tax) {
			gStorage.taxons.setChildList(gStorage.lists.speclist.list.filter(x => x.p_id === tax.id).sort(sortTaxons));

			tax = gStorage.lists.speclist.list.find(x => x.id === tax.p_id);
			while (tax) {
				if (i === 0) {
					gStorage.taxons.setUpperTaxon1(tax);
					i++;
				} else if (i === 1) {
					gStorage.taxons.setUpperTaxon2(tax);
					i++;
				} else if (i === 2) {
					gStorage.taxons.setUpperTaxon3(tax);
					i++;
				} else if (i === 3) {
					gStorage.taxons.setUpperTaxon4(tax);
					i++;
				}

				let id = tax.p_id;

				tax = gStorage.lists.speclist.list.find(x => x.id === id);
			}
		} else {
			gStorage.taxons.setChildList([]);
		}

		while (i < 4) {
			if (i === 0) {
				gStorage.taxons.setUpperTaxon1(null);
			} else if (i === 1) {
				gStorage.taxons.setUpperTaxon2(null);
			} else if (i === 2) {
				gStorage.taxons.setUpperTaxon3(null);
			} else if (i === 3) {
				gStorage.taxons.setUpperTaxon4(null);
			}

			i++;
		}
	}

	const taxLink = (event) => {
		taxChange(gStorage.lists.speclist.list.find(x => x.id === event));
	}

	function taxGetSpecName(tax) {
		return getShortSpecName(tax, gStorage.conn.user);
	}

	function sortTaxons(t1, t2) {
		let n1 = taxGetSpecName(t1);
		let n2 = taxGetSpecName(t2);

		return n1.localeCompare(n2, 'fi');
	}

	function taxonRecAction(cmd, rec) {
		console.log('taxonRecAction', cmd);

		switch(cmd) {
		case 'previous':
			if (prevTaxonValid()) {
				prevTaxon();
			}
			break;
		case 'next':
			if (nextTaxonValid()) {
				nextTaxon();
			}
			break;
		case 'taxonomy':
			handleTabChange(null, TAB_TAX);
			break;
		case 'stats':
			handleTabChange(null, TAB_STATS);
			break;
		case 'map':
			handleTabChange(null, TAB_MAP);
			break;
		case 'description':
			handleTabChange(null, TAB_DESC);
			break;
		case 'media':
			handleTabChange(null, TAB_MEDIA);
			break;
		case 'halias':
			handleTabChange(null, TAB_HALIAS);
			break;
		case 'atlas':
			handleTabChange(null, TAB_ATLAS);
			break;
		case 'bl':
			handleTabChange(null, TAB_BL);
			break;
		case 'migration':
			handleTabChange(null, TAB_MIGR);
			break;
		case 'references':
			handleTabChange(null, TAB_REFS);
			break;
		default:
			const spec = gStorage.lists.speclist.list.find(x => x.fi.toLowerCase() === cmd);
			if (spec) {
				console.log('spec', spec.fi);
				taxChange(spec);
			} else {
				console.error('Species', cmd, 'not found!');
			}
		}
	}

	if (gStorage.taxons.pendTaxon) {
		taxChange(gStorage.taxons.pendTaxon);
		gStorage.taxons.setPendTaxon(null);
	}

	const tax = gStorage.taxons.centerTaxon;
	
	return (
		<div>
			<ObsAppBar {...props} getheader={getheader}/>
			<Grid container direction="row" spacing={0} justifyContent="center">
				<Grid size={{xs: 12}} align={'center'} id='taxonname'>
					<Autocomplete
						options={gStorage.lists.speclist.list.slice().filter(x => (x.t_type !== TT_SUBSPEC)).sort(sortTaxons)}
						getOptionLabel={option => {
							if (option.t_type !== TT_SPEC)
								return getShortSpecName(option, gStorage.conn.user) + ' (' + t(taxStateDesc(option.t_type)) + ')';

							return getSpecName(option, gStorage.conn.user);
						}}
						value={gStorage.taxons.centerTaxon}
						onChange={action((e, value) => taxChange(value))}
						style={{width: 300, margin: 8}}
						autoSelect
						renderInput={params => (
							<TextField {...params} label={t('taxons.taxon')} variant="outlined" size="small" fullWidth />
						)}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<Tabs style={{width: 300}}
						id='taxontab'
						value={gStorage.taxons.tab} 
						onChange={handleTabChange} 
						align={'center'}
						indicatorColor="primary"
						textColor="primary"
						variant="scrollable"
						scrollButtons="auto">
						<Tab
							value={TAB_TAX}
							label={t('taxons.taxonomy')}
							disabled={!tax}/>
						<Tab
							value={TAB_STATS}
							label={t('taxons.statistics')} 
							disabled={!tax || !gStorage.conn.online ||
								(tax.t_type !== TT_SPEC && tax.t_type !== TT_SUBSPEC)}/>
						<Tab
							value={TAB_MAP}
							label={t('taxons.map')}
							disabled={!tax || !gStorage.conn.online ||
								(tax.t_type !== TT_SPEC && tax.t_type !== TT_SUBSPEC)}/>
						<Tab
							value={TAB_DESC}
							label={t('taxons.description')}
							disabled={!tax || !gStorage.conn.online}/>
						<Tab
							value={TAB_MEDIA}
							label={t('taxons.media')}
							disabled={!tax || !gStorage.conn.online}/>
						<Tab
							value={TAB_HALIAS}
							label={t('taxons.halias')}
							disabled={!tax || !gStorage.conn.online ||
								(tax.t_type !== TT_SPEC && tax.t_type !== TT_SUBSPEC)}/>
						<Tab
							value={TAB_ATLAS}
							label={t('taxons.atlas')}
							disabled={!tax || !gStorage.conn.online ||
								(tax.t_type !== TT_SPEC && tax.t_type !== TT_SUBSPEC) ||
								!tax.fin_breeder}/>
						{gStorage.conn.user.bl_notification ? <Tab
							value={TAB_BL}
							label={t('taxons.bl')}
							disabled={!tax || !gStorage.conn.online}/> : null}
						<Tab
							value={TAB_MIGR}
							label={t('taxons.migration')}
							disabled={!tax || !gStorage.conn.online}/> : null}
						<Tab
							value={TAB_REFS}
							label={t('taxons.references')}
							disabled={!tax || !gStorage.conn.online}/>
					</Tabs>
				</Grid>

				<Taxonomy taxLink={action((e) => taxLink(e))}/>
				<TaxDesc/>
				<TaxBl/>
				<TaxStats/>
				<TaxMedia/>
				<TaxMap/>
				<TaxHalias/>
				<TaxAtlas/>
				<TaxMigration/>
				<TaxReferences/>
			</Grid>
			<BottomBar 
				onPrevValid={prevTaxonValid}
				onPrev={action(() => prevTaxon())}
				onNext={action(() => nextTaxon())}
				onNextValid={nextTaxonValid}
				rec={{action: taxonRecAction, continuous: false}}
			/>
		</div>
	);
});

export default Taxons;
